<template>
  <v-card class="pa-5 ml-10 mr-10 mt-5">
    <v-card-title>Module</v-card-title>
    <v-card-text>
      <v-data-table
        hide-default-footer
        items-per-page="20"
        class="border-table"
        density="compact"
        :headers="headers"
        hide-no-data
        item-value="id"
        :items="items">
        <template v-slot:item.active="{ item }">
          <v-checkbox
            :data-cy="'module-' + item.id + '-active'"
            :true-value="1"
            :false-value="0"
            :model-value="item.slots"
            @update:model-value="($event) => changeValue(item.value, $event)"
            hide-details>
          </v-checkbox>
          <span v-if="item.monthEnd">(Noch bis zum Ende des Monats)</span>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-text>
      <v-row class="mt-5">
        <v-col
          cols="6"
          style="display: grid; justify-content: end"
          >Monatliche Kosten</v-col
        >
        <v-col
          cols="6"
          style="display: grid; justify-content: end">
          <s
            data-cy="old-monthly-costs"
            v-if="oldMonthlyCost !== 0 && oldMonthlyCost !== monthlyCost"
            >{{ oldMonthlyCost }} €</s
          >
          <span data-cy="final-monthly-costs">{{ monthlyCost }} €</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="saveModules(save)">Speichern</v-btn>
    </v-card-actions>
  </v-card>
  <v-dialog
    v-model="dialog.open"
    persistent>
    <LicenceReviewPopup
      @close="dialog.open = false"
      @save="dialog.onSuccess"
      :monthly-costs="monthlyCost"
      :yearly-costs="0"
      :additional-costs="additionalCharge.additionalPrice"
      :remaining-days="additionalCharge.remainingDays"
      :initial-items="initialItems"
      :items="items"
      :modules-added="modulesAdded"
      :modules-added-additional="modulesAddedAdditional"
      :modules-removed="modulesRemoved" />
  </v-dialog>
</template>

<script lang="ts" setup>
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { ref, toRef } from "vue";
import { useTranslation } from "i18next-vue";
import { useMainStore } from "@/stores/mainStore";
import { useModules } from "./moduleComposable";
import LicenceReviewPopup from "@/components/dialogs/LicenceReviewPopup.vue";

const createConfirm = useConfirm();
const createSnackbar = useSnackbar();
const { t } = useTranslation();
const mainStore = useMainStore();

const dialog = ref({
  open: false,
  onSuccess: () => {}
});

const emit = defineEmits(["moduleUpdate"]);
const props = defineProps({
  slots: Object,
  allSlots: Object,
  save: Function
});

const model = defineModel();

defineExpose({
  saveModules
});

const {
  headers,
  items,
  oldMonthlyCost,
  monthlyCost,
  modulesAdded,
  modulesAddedAdditional,
  modulesRemoved,
  additionalCharge,
  initialItems
} = useModules(
  true,
  toRef(() => model.value),
  toRef(() => props.allSlots)
);

function changeValue(item: number, value: number) {
  console.log(value);
  model.value[item] = value;
}

function saveModules(callback: () => void) {
  dialog.value.onSuccess = callback;
  dialog.value.open = true;
}
</script>
